import axiosInstance from "./axios";

export const fetchServices = (filters = {}, search = "") => {
  const params = new URLSearchParams();

  if (filters.project_id) params.append("project_id", filters.project_id);
  if (filters.service_type) params.append("service_type", filters.service_type);
  if (filters.status) params.append("status", filters.status);
  if (search) params.append("search", search);

  return axiosInstance.get(`/services?${params.toString()}`);
};

export const exportServices = (filters = {}, search = "") => {
  const params = new URLSearchParams();

  if (filters.project_id) params.append("project_id", filters.project_id);
  if (filters.service_type) params.append("service_type", filters.service_type);
  if (filters.status) params.append("status", filters.status);
  if (search) params.append("search", search);
  params.append("export", "1");

  return axiosInstance.get(`/services?${params.toString()}`, {
    responseType: 'blob'
  });
};

export const fetchServiceById = (id) => {
  return axiosInstance.get(`/services/${id}`);
};

export const createService = (data) => {
  return axiosInstance.post("/services", data);
};

export const updateService = (id, data) => {
  return axiosInstance.put(`/services/${id}`, data);
};

export const deleteService = (id) => {
  return axiosInstance.delete(`/services/${id}`);
};

export const fetchServiceCalendar = (filters = {}) => {
  const params = new URLSearchParams();

  if (filters.project_id) params.append("project_id", filters.project_id);
  if (filters.service_id) params.append("service_id", filters.service_id);
  if (filters.service_status)
    params.append("service_status", filters.service_status);
  if (filters.service_by) params.append("service_by", filters.service_by);
  if (filters.date) params.append("date", filters.date);
  if (filters.upcoming) params.append("upcoming", "1");
  if (filters.per_page) params.append("per_page", filters.per_page);

  return axiosInstance.get(`/service-calendar?${params.toString()}`);
};

export const updateServiceCalendarEntry = (id, data) => {
  return axiosInstance.put(`/service-calendar/${id}`, data);
};

export const fetchServiceCalendarEntry = (id) => {
  return axiosInstance.get(`/service-calendar/${id}`);
};

export const downloadChecklistPdf = (entryId) => {
  return axiosInstance.get(`/service-calendar/${entryId}/checklist-pdf`, {
    responseType: "blob",
  });
};

export const openChecklistPdf = async (entryId) => {
  // The axios interceptor unwraps response.data, so we get the blob directly
  const blob = await axiosInstance.get(
    `/service-calendar/${entryId}/checklist-pdf`,
    { responseType: "blob" },
  );

  // Validate response is actually a PDF (server errors come back as HTML/JSON blobs)
  if (blob instanceof Blob && blob.type && !blob.type.includes("pdf")) {
    const text = await blob.text();
    let errorMsg = "Server returned an error instead of PDF";
    try {
      const json = JSON.parse(text);
      errorMsg = json.message || errorMsg;
    } catch {
      // not JSON, use default message
    }
    throw new Error(errorMsg);
  }

  const pdfBlob = new Blob([blob], { type: "application/pdf" });
  const url = window.URL.createObjectURL(pdfBlob);
  window.open(url, "_blank");
};

export const openAmcPdf = async (serviceId) => {
  // The axios interceptor unwraps response.data, so we get the blob directly
  const blob = await axiosInstance.get(`/services/${serviceId}/amc-pdf`, {
    responseType: "blob",
  });

  // Validate response is actually a PDF (server errors come back as HTML/JSON blobs)
  if (blob instanceof Blob && blob.type && !blob.type.includes("pdf")) {
    const text = await blob.text();
    let errorMsg = "Server returned an error instead of PDF";
    try {
      const json = JSON.parse(text);
      errorMsg = json.message || errorMsg;
    } catch {
      // not JSON, use default message
    }
    throw new Error(errorMsg);
  }

  const pdfBlob = new Blob([blob], { type: "application/pdf" });
  const url = window.URL.createObjectURL(pdfBlob);
  window.open(url, "_blank");
};
